<mat-tab-group dynamicHeight class="linq-tab-bar">
	<mat-tab label="Fund Management">
		<ss-notifications-grid #fundGrid [notifications]="fundNotifications" [roles]="roles"></ss-notifications-grid>
	</mat-tab>
	<mat-tab label="Employee Portal">
		<mat-accordion>
			<ss-notifications-grid #portalSystemGrid [notifications]="portalSystemNotifications" [roles]="roles"></ss-notifications-grid>
			<ss-notifications-grid #portalEmployeeGrid [notifications]="portalEmployeeNotifications" [employee]="true" [expanded]="false"
				[roles]="roles">
			</ss-notifications-grid>
		</mat-accordion>
	</mat-tab>
</mat-tab-group>
